import { Box, Grid } from "@mui/material";

export const MediaTitleFilter = ({
  mediaTitleChoices,
  teaserMediaTitleFilter,
  toggleMediaTitle,
  dfpMediaTitleLabels,
  classes,
}) => (
  <Grid
    item
    xs={12}
    sm={12}
    md={12}
    style={{
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
    }}
  >
    {mediaTitleChoices.map((mt) => (
      <span
        key={mt}
        onClick={toggleMediaTitle(mt)}
        style={{
          display: "flex",
          flexDirection: "row",
          cursor: "pointer",
        }}
        className={
          teaserMediaTitleFilter.includes(mt)
            ? classes.mediaTitlesSelected
            : classes.mediaTitlesNotSelected
        }
      >
        <Box style={{ display: "flex" }}>
          <img
            src={
              teaserMediaTitleFilter.includes(mt)
                ? "/img/icons/check-circle-selected.svg"
                : "/img/icons/check-circle-not-selected.svg"
            }
            alt={
              teaserMediaTitleFilter.includes(mt) ? "Selected" : "Not selected"
            }
            style={{
              width: "14px",
              height: "14px",
              alignSelf: "center",
              marginRight: "5px",
            }}
          />
        </Box>
        <span>{dfpMediaTitleLabels[mt] || mt}</span>
      </span>
    ))}
  </Grid>
);
